import FieldLabel from '../forms/FieldLabel';
import { FiArrowUp, FiArrowDown, FiTrash2 } from 'react-icons/fi';
import AdminIconButton from './AdminIconButton';
import AdminReorderList from './AdminReorderList';

function move(items, index, direction) {
  const destination = index + direction;
  if (destination < 0 || destination >= items.length) return items;
  const next = [...items];
  const [item] = next.splice(index, 1);
  next.splice(destination, 0, item);
  return next;
}

function RepeaterActions({ label, index, total, onMove, onRemove, allowEmpty = false }) {
  return (
    <div className="admin-repeater-actions">
      <AdminIconButton label={`Move ${label} ${index + 1} earlier`} icon={FiArrowUp} onClick={() => onMove(-1)} disabled={index === 0} />
      <AdminIconButton label={`Move ${label} ${index + 1} later`} icon={FiArrowDown} onClick={() => onMove(1)} disabled={index === total - 1} />
      <AdminIconButton label={`Remove ${label} ${index + 1}`} icon={FiTrash2} className="admin-danger" onClick={onRemove} disabled={!allowEmpty && total === 1} />
    </div>
  );
}

export function PairRepeater({ legend, help, itemLabel, items, onChange, flat = false }) {
  const update = (index, field, value) => onChange(items.map((item, itemIndex) => itemIndex === index ? { ...item, [field]: value } : item));
  return (
    <fieldset className={`admin-repeater${flat ? ' admin-repeater-flat' : ''}`}>
      <legend>{legend}</legend>
      {help && <p className="admin-field-help">{help}</p>}
      <AdminReorderList items={items} onChange={onChange} itemLabel={itemLabel}>
        {({ item, index, handle }) => <>
            <div className="admin-repeater-row-heading">{handle}<RepeaterActions label={itemLabel} index={index} total={items.length} onMove={(direction) => onChange(move(items, index, direction))} onRemove={() => onChange(items.filter((_, itemIndex) => itemIndex !== index))} /></div>
            <FieldLabel>Title<input value={item.title} onChange={(event) => update(index, "title", event.target.value)} required /></FieldLabel>
            <FieldLabel>Description<textarea rows="3" value={item.description} onChange={(event) => update(index, "description", event.target.value)} required /></FieldLabel>
        </>}
      </AdminReorderList>
      <button type="button" className="admin-add-row" onClick={() => onChange([...items, { title: "", description: "" }])}>Add {itemLabel.toLowerCase()}</button>
    </fieldset>
  );
}

export function CategoryRepeater({ items, onChange, flat = false }) {
  return (
    <fieldset className={`admin-repeater admin-category-repeater${flat ? ' admin-repeater-flat' : ''}`}>
      <legend>Best-fit categories</legend>
      <p className="admin-field-help">These appear as category chips on the Media Kit.</p>
      <AdminReorderList items={items} onChange={onChange} itemLabel="Category" rowClassName="compact">
        {({ item, index, handle }) => <>
            <FieldLabel>{handle}<input value={item} onChange={(event) => onChange(items.map((value, itemIndex) => itemIndex === index ? event.target.value : value))} required /></FieldLabel>
            <RepeaterActions label="Category" index={index} total={items.length} onMove={(direction) => onChange(move(items, index, direction))} onRemove={() => onChange(items.filter((_, itemIndex) => itemIndex !== index))} />
        </>}
      </AdminReorderList>
      <button type="button" className="admin-add-row" onClick={() => onChange([...items, ""])}>Add category</button>
    </fieldset>
  );
}

export function CountryRepeater({ items = [], onChange }) {
  const update = (index, field, value) => onChange(items.map((item, itemIndex) => itemIndex === index ? { ...item, [field]: value } : item));
  return (
    <fieldset className="admin-repeater">
      <legend>Top countries</legend>
      <p className="admin-field-help">Use the country code and percentage shown in TikTok Analytics.</p>
      {items.length === 0 && <p className="admin-empty-note">No countries added.</p>}
      <AdminReorderList items={items} onChange={onChange} itemLabel="Country" rowClassName="country">
        {({ item: country, index, handle }) => <>
            <div className="admin-repeater-row-heading">{handle}<RepeaterActions label="Country" index={index} total={items.length} allowEmpty onMove={(direction) => onChange(move(items, index, direction))} onRemove={() => onChange(items.filter((_, itemIndex) => itemIndex !== index))} /></div>
            <FieldLabel>Code<input value={country.code || ""} maxLength="2" onChange={(event) => update(index, "code", event.target.value.toUpperCase())} placeholder="US" required /></FieldLabel>
            <FieldLabel>Name<input value={country.name || ""} onChange={(event) => update(index, "name", event.target.value)} placeholder="United States" required /></FieldLabel>
            <FieldLabel>Percentage<input type="number" min="0" max="100" step="0.1" value={country.percent ?? ""} onChange={(event) => update(index, "percent", event.target.value)} required /></FieldLabel>
        </>}
      </AdminReorderList>
      <button type="button" className="admin-add-row" onClick={() => onChange([...items, { code: "", name: "", percent: "" }])}>Add country</button>
    </fieldset>
  );
}
